import React from 'react';
import '../styles/skills.css';

const skillCategories = [
    {
        title: "Data Engineering",
        skills: [
            { name: "Apache Spark", icon: "⚡", context: "Processed 1TB+ data for real-time analytics in a finance platform." },
            { name: "Apache Kafka", icon: "🔄", context: "Implemented a streaming pipeline for log aggregation and monitoring." },
            { name: "Apache Airflow", icon: "🔄", context: "Orchestrated ETL workflows for healthcare data pipelines." },
            { name: "SQL & NoSQL", icon: "🗃️", context: "Designed database schemas for scalable applications." },
            { name: "ETL Pipeline", icon: "⚙️", context: "Developed ETL processes to integrate data from multiple sources." },
        ],
    },
    {
        title: "AI & Machine Learning",
        skills: [
            { name: "TensorFlow", icon: "🤖", context: "Built deep learning models for image classification." },
            { name: "Hugging Face", icon: "🤗", context: "Deployed NLP models for sentiment analysis and chatbots." },
            { name: "Scikit-learn", icon: "📊", context: "Implemented predictive models for sales forecasting." },
            { name: "Natural Language Processing", icon: "🔤", context: "Developed text summarization tools for content platforms." },
            { name: "Computer Vision", icon: "👁️", context: "Created object detection models for surveillance systems." },
        ],
    },
    {
        title: "Cloud & DevOps",
        skills: [
            { name: "Google Cloud Platform", icon: "☁️", context: "Managed cloud infrastructure for scalable applications." },
            { name: "AWS", icon: "☁️", context: "Automated deployments using AWS CloudFormation." },
            { name: "Docker", icon: "🐳", context: "Containerized microservices for cross-environment consistency." },
            { name: "Kubernetes", icon: "🎮", context: "Deployed containerized applications with Kubernetes clusters." },
            { name: "CI/CD", icon: "🔄", context: "Set up pipelines for continuous integration and delivery." },
        ],
    },
    {
        title: "Programming & Development",
        skills: [
            { name: "Python", icon: "🐍", context: "Primary language for data engineering and ML projects." },
            { name: "JavaScript", icon: "⚡", context: "Built interactive web applications using React.js." },
            { name: "Java", icon: "☕", context: "Developed REST APIs for enterprise-level applications." },
            { name: "Git", icon: "📦", context: "Collaborated on version-controlled projects with teams." },
        ],
    },
];
const Skills = () => {
    return (
        <div className="skills-section">
            <div className="skills-grid">
                {skillCategories.map((category, index) => (
                    <div key={index} className="skill-section">
                        <h3>{category.title}</h3>
                        <div className="skill-list">
                            {category.skills.map((skill, idx) => (
                                <div key={idx} className="skill-item">
                                    <div className="skill-icon">{skill.icon}</div>
                                    <div className="skill-info">
                                        <h4>{skill.name}</h4>
                                        <p>{skill.context}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};


export default Skills;
